<template>
  <el-dialog
    title="第三方連結免責聲明"
    :visible.sync="$parent.dialogStateVisible"
    width="80%"
    :before-close="handleClose">
    <div class="terms_info">
      <p>本公司與第三方網站有關的任何事項（包括但不限於其內容或其設置）。不會對任何第三方的刑事行為負責,例如網絡入侵、釣魚式攻擊、網站綁架或任何其他類似性質的刑事行為。進入及／或使用任何第三方網站將受該網站擁有人／提供者的條款及條件所規管（包括但不限於該網站的私隱聲明）及必須遵守該等條款及條件。提供連接至第三方網站的超連接，並不認可、核准、保證或推薦任何第三方、任何第三方網站或其任何產品、服務或資訊。本公司不承擔與任何第三方網站有關的或因而產生的法律責任或任何其他責任。</p>
      <p>(一)我們不保證您在第三方網站上提供之個人資料及/或其他資訊的安全性。為維護我們所擁有或控制與您有關之個人資料的安全性，我們確實實施了各種安全措施。您的個人資料包含在安全網路之後，只有具有該系統之特殊存取權且必須對個人資料保密的有限人員可以存取。當您下訂單或存取個人資料時，我們會提供安全伺服器以供使用。您提供的所有個人資料或敏感資訊都會以加密方式存放在我們的資料庫中，只有上述人員可以存取。</p>
      <p>(二)為嘗試提供更高的價值，我們可能會選擇將各種第三方網站連結至本平台，或是將第三方網站放在本平台框架中。我們可能也會參與聯合品牌和其他關係，以便為訪客提供電子商務及其他服務與功能。所連結的網站有個別和獨立的隱私權政策及安全措施。即使該第三方與我們有關，我們對於這些連結網站也沒有控制權，而且每一個連結網站都有不受我們約束的個別隱私權和資料收集作法。我們可能不會收到由聯合品牌夥伴或第三方網站 (即使是在我們的本網站上或透過我們的本平台提供) 所收集的資料。</p>
      <p>(三)因此，我們對於這些連結網站的內容、安全措施 (或缺乏該安全措施) 及活動，沒有任何責任或義務。這些連結網站只是為了方便起見而提供，因此當您存取這些網站時，應自行承擔風險。儘管如此，我們仍設法保護本平台及置於各網站之連結的完整性，因此歡迎提出與這些連結網站相關的意見 (包括但不限於特定連結無法運作的狀況)。</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">確 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import FN from '@/components/fn'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'dialog',
  components: {
  },
  mixins: [FN],
  props: {
    data: Object
  },
  data() {
    return {
      
    }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.$parent.dialogStateVisible = false
    }
  }
}
</script>
